import { useQuery } from '@tanstack/react-query';
import type { Equipment, ListEquipmentsResponse } from 'shared';
import { api } from '@/lib/api';

/**
 * Fetch the equipamentos belonging to a digital center. Disabled until the
 * participant has checked in (no centroId means no list to show).
 *
 * The endpoint accepts an `estado` query param but the backend value
 * "Em utilização" contains a non-ASCII space, so we ask for everything and
 * narrow on the client to keep the URL boring.
 *
 * `staleTime` defaults to 60s; screens that need equipment-state changes to
 * surface quickly (Início, Reservas) pass a shorter window.
 */
export function useEquipmentsByCentro(centroId: number | undefined, staleTime = 60_000) {
  return useQuery({
    queryKey: ['equipments', 'by-centro', centroId],
    queryFn: () =>
      api.get<ListEquipmentsResponse>(`/api/equipments?digitalCenterID=${centroId}&limit=100`),
    enabled: typeof centroId === 'number' && centroId > 0,
    staleTime,
  });
}

/** GET /api/equipments/{id}. Disabled until a positive id is supplied. */
export function useEquipmentById(id: number | undefined) {
  return useQuery({
    queryKey: ['equipments', 'by-id', id],
    queryFn: () => api.get<Equipment>(`/api/equipments/${id}`),
    enabled: typeof id === 'number' && id > 0,
    staleTime: 60_000,
  });
}
